<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { processSteps } from '../../constants/commission-process';
import { useProgressStore } from '../../stores/progressStore';

const progressStore = useProgressStore();
const { currentStep } = storeToRefs(progressStore);
const stepDisplay = (stepId: number) => stepId.toString().padStart(2, '0');
</script>

<template>
  <div class="steps__container">
    <div class="steps__track">
      <div
        v-for="(step, i) in processSteps"
        :key="step.id"
        :class="[
          'steps__item',
          {
            'steps__item--active': currentStep === step.id,
            'steps__item--completed': currentStep > step.id,
          },
        ]"
      >
        <div class="steps__circle">
          <template v-if="currentStep === step.id">
            <span>{{ stepDisplay(step.id) }}</span>
          </template>
        </div>
        <div v-if="i < processSteps.length - 1" class="steps__line"></div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.steps__container {
  height: 3.5em;
  max-height: 52px;
  justify-content: center;
  padding: 0 20px;
  display: flex;
  align-items: center;
  box-sizing: content-box;
}

.steps__track {
  display: flex;
  align-items: center;
  width: 100%;
}

.steps__item {
  display: flex;
  align-items: center;
  flex: 1 1 auto;

  &:last-child {
    flex-grow: 0;
  }
}

.steps__circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;

  border-radius: 50%;
  border: 2px solid @color-mid-green;
}

.steps__line {
  flex-grow: 1;
  height: 2px;
  background-color: @color-mid-green;
  min-width: 24px;
}

.steps__item--completed {
  .steps__circle {
    background: @color-primary;
    border: 2px solid @color-primary;
  }
  .steps__line {
    background-color: @color-primary;
  }
}

.steps__item--active {
  .steps__circle {
    background: @color-primary;
    border: 2px solid @color-primary;

    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    color: white;
  }
}
</style>
